import { render, staticRenderFns } from "./NormalMulti.vue?vue&type=template&id=6fd522c4&"
import script from "./NormalMulti.vue?vue&type=script&lang=js&"
export * from "./NormalMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports